import type { FC } from 'react';

import styles from './promo.module.css';

type Props = {
  title: string | null | undefined;
  caption: string | null | undefined;
  category?: string | null | undefined;
  link?: string | null | undefined;
  src: string | null | undefined;
};

const PromoSlide: FC<Props> = ({ title, caption, category, link, src }) => (
  <div className={styles.slideContent}>
    <div className={styles.imageContainer}>
      {src && <img src={src} alt="Promo" />}
    </div>
    <div className={styles.caption}>
      <span>{category}</span>
      <h2>{title}</h2>
      <p>{caption}</p>
      {link && (
        // biome-ignore lint/a11y/noAmbiguousAnchorText: link text copy change pending review
        <a
          href={link}
          target="_blank"
          className={styles.learnMore}
          rel="noopener noreferrer"
        >
          Learn more
        </a>
      )}
    </div>
  </div>
);

export default PromoSlide;
